export const translations = {
  es: {
    brand: "GalascioDAS",
    tagline: "Sistema de Análisis del Discurso · Estrategia Política",
    nav_login: "Acceder",
    nav_register: "Registrarse",
    nav_logout: "Salir",
    nav_dashboard: "Panel",
    hero_eyebrow: "DECODIFICACIÓN ESTRATÉGICA DEL DISCURSO POLÍTICO",
    hero_title: "No se trata de verdad o mentira.\nSe trata de arquitectura estratégica.",
    hero_lead:
      "GalascioDAS no evalúa si un político dice la verdad. Decodifica la estructura retórica, el framing cognitivo, y la intención profunda detrás de cada palabra pronunciada en el espacio público.",
    hero_cta_start: "Iniciar análisis",
    hero_cta_learn: "Cómo funciona",
    disciplines_title: "Cuatro disciplinas integradas",
    disc_1_t: "Análisis retórico computacional",
    disc_1_d: "Detección y nomenclatura algorítmica de dispositivos retóricos y mecanismos de persuasión.",
    disc_2_t: "Lingüística crítica del discurso (CDA)",
    disc_2_d: "Examen de elisiones semánticas, eufemismos y vocabulario de activación identitaria.",
    disc_3_t: "Modelado de intención estratégica",
    disc_3_d: "Inferencia del objetivo político real más allá del tema declarado.",
    disc_4_t: "Análisis de coherencia narrativa",
    disc_4_d: "Evaluación del marco cognitivo instalado y de lo que queda intencionalmente fuera del campo.",
    phases_title: "Protocolo de cinco fases",
    phase_1: "Radiografía Superficial",
    phase_2: "Detección de Mecanismos Retóricos",
    phase_3: "Análisis de Marcos Cognitivos",
    phase_4: "Inferencia de Estrategia Profunda",
    phase_5: "Mapa Estratégico Final",
    footer_signature: "GalascioDAS™ · Sistema desarrollado por Michael A. Galascio",
    // Sprint 1 UX strings
    cta_paste_hint: "Pega un fragmento de discurso para empezar.",
    tags_hint:
      "Añade etiquetas (ej. #actor) para activar tendencias agregadas y reportes PDF de este actor.",
    delete_confirm:
      "¿Eliminar este análisis? También se perderán sus etiquetas y press kit asociados.",
    press_kit_share_hint: "Activa el press kit para habilitar el compartir.",
    nav_my_press_kit: "Mi Press Kit",
    detail_press_kit_title: "Generar Press Kit del análisis",
    detail_press_kit_lead:
      "Resumen ejecutivo, citas destacadas y tweet listo para difundir.",
    tip_sophistication:
      "Sofisticación estratégica: nivel de elaboración del discurso (básico → experto), inferido del uso combinado de mecanismos retóricos, framing y profundidad estratégica.",
    tip_mechanism:
      "Mecanismo retórico dominante: técnica persuasiva principal detectada (ej. polarización, apelación al miedo, falsa equivalencia, hipérbole moral).",
    tip_framing:
      "Framing cognitivo: marco interpretativo activado para condicionar cómo se entienden los hechos (ej. marco de protección, marco de víctima, marco de futuro).",
    tip_deep_strategy:
      "Estrategia profunda: objetivo político inferido más allá del tema declarado (ej. consolidar base electoral, desplazar al rival, instalar agenda).",
    sample_text_btn: "Cargar discurso de muestra",
    cost_est_hint: "Coste estimado por análisis (aproximado).",
    // /docs page
    docs_nav: "Documentación",
    docs_eyebrow: "· DOCUMENTACIÓN · METODOLOGÍA",
    docs_title: "Cómo funciona GalascioDAS",
    docs_lead:
      "GalascioDAS no evalúa si un político dice la verdad. Decodifica la estructura retórica, el framing cognitivo y la intención profunda detrás de cada palabra pronunciada en el espacio público. Esta página explica la metodología, el protocolo de cinco fases y los límites del sistema.",
    docs_what_eyebrow: "· QUÉ ES GALASCIODAS",
    docs_what_title: "Un sistema, cuatro disciplinas",
    docs_what_body:
      "GalascioDAS™ es un sistema de análisis del discurso político desarrollado por Michael A. Galascio. Integra análisis retórico computacional, lingüística crítica del discurso (CDA), modelado de intención estratégica y análisis de coherencia narrativa. No es un fact-checker ni un detector de sesgos: es un instrumento para hacer visible la arquitectura estratégica del discurso público.",
    docs_protocol_eyebrow: "· PROTOCOLO · CINCO FASES",
    docs_protocol_title: "Cómo se analiza cada discurso",
    docs_phase_1_d:
      "Identificación del actor, registro lingüístico, tono dominante, tema declarado, audiencia evocada. Es la lectura mínima antes de cualquier inferencia.",
    docs_phase_2_d:
      "Detección y nomenclatura algorítmica de mecanismos persuasivos: polarización, apelación al miedo, falsa equivalencia, hipérbole moral, victimización, deshumanización, anclaje histórico, entre otros.",
    docs_phase_3_d:
      "Identificación del marco interpretativo activado: protección, víctima, futuro, decadencia, restauración, frontera. El marco condiciona cómo el receptor entiende los hechos antes de evaluarlos.",
    docs_phase_4_d:
      "Inferencia del objetivo político real, más allá del tema declarado: consolidar base, desplazar al rival, instalar agenda, neutralizar crisis, reconstruir capital simbólico.",
    docs_phase_5_d:
      "Síntesis con un veredicto estratégico, mecanismo dominante, marco cognitivo principal y nivel de sofisticación (básico → experto).",
    docs_glossary_eyebrow: "· GLOSARIO",
    docs_glossary_title: "Términos clave",
    docs_term_sophistication: "Sofisticación estratégica",
    docs_term_sophistication_d:
      "Nivel de elaboración del discurso, inferido del uso combinado de mecanismos retóricos, framing y profundidad estratégica. Escala: básico, intermedio, avanzado, experto.",
    docs_term_framing: "Framing cognitivo",
    docs_term_framing_d:
      "Marco interpretativo activado para condicionar cómo se entienden los hechos. No es lo que se dice, sino la lente con la que se invita a leer lo que se dice.",
    docs_term_mechanism: "Mecanismo retórico",
    docs_term_mechanism_d:
      "Técnica persuasiva concreta detectada en el texto. Cada discurso suele tener un mecanismo dominante y otros secundarios.",
    docs_term_objective: "Objetivo estratégico",
    docs_term_objective_d:
      "Propósito político inferido del discurso, más allá del tema explícito. Se expresa como acción: consolidar, desplazar, instalar, neutralizar.",
    docs_term_narrative: "Narrativa",
    docs_term_narrative_d:
      "Hilo simbólico que conecta varios discursos del mismo actor. La narrativa se observa en agregados (Tendencias), no en un análisis aislado.",
    docs_term_derived: "Inferencia derivada",
    docs_term_derived_d:
      "Resultado que no proviene de un nuevo análisis LLM, sino del agregado estadístico de análisis ya guardados (Tendencias, briefings, distribuciones).",
    docs_not_eyebrow: "· LÍMITES",
    docs_not_title: "Qué NO hace GalascioDAS",
    docs_not_1_t: "No verifica hechos",
    docs_not_1_d:
      "Si un discurso afirma datos económicos o eventos históricos, GalascioDAS no contrasta esa información con fuentes. La verificación factual requiere otras herramientas.",
    docs_not_2_t: "No sustituye juicio experto",
    docs_not_2_d:
      "Es un instrumento de apoyo. Un analista político, periodista o investigador sigue siendo necesario para interpretar el resultado en su contexto.",
    docs_not_3_t: "No afirma intención psicológica como hecho",
    docs_not_3_d:
      "La fase de estrategia profunda es una inferencia probabilística sobre el discurso, no un diagnóstico sobre la mente del actor. No se confunde retórica con personalidad.",
    docs_use_eyebrow: "· CASOS DE USO",
    docs_use_title: "Para quién",
    docs_use_journalists_t: "Periodistas",
    docs_use_journalists_d:
      "Identificar el mecanismo dominante de una declaración y citarlo con precisión técnica en lugar de adjetivos vagos como 'demagogia' o 'populismo'.",
    docs_use_consultants_t: "Consultores",
    docs_use_consultants_d:
      "Auditar el discurso propio o ajeno, detectar saturación de un mecanismo, evaluar si la sofisticación está alineada con la audiencia objetivo.",
    docs_use_researchers_t: "Investigadores",
    docs_use_researchers_d:
      "Construir corpus comparativos, generar briefings PDF por actor o tema, observar evolución longitudinal de marcos cognitivos.",
    docs_use_comms_t: "Equipos de comunicación",
    docs_use_comms_d:
      "Press Kit automático, alertas semanales por actor monitorizado, exportación a Markdown/PDF para informes internos.",
    docs_cta_try: "Probar análisis",
    docs_cta_sample: "Cargar discurso de muestra",
    // Onboarding modal
    onboarding_eyebrow: "· BIENVENIDO · GUÍA RÁPIDA",
    onboarding_title: "Tres pasos para empezar",
    onboarding_lead:
      "Tómate 30 segundos para entender el flujo. Puedes saltar esta guía cuando quieras.",
    onboarding_step_1_t: "Analizar",
    onboarding_step_1_d:
      "Pega un fragmento de discurso, sube un archivo o graba audio. Elige uno de los tres modelos (claude / GPT-5.2 / gemini). Pulsa Ejecutar análisis. Si nunca has usado el sistema, prueba con el botón \"Cargar discurso de muestra\".",
    onboarding_step_2_t: "Guardar y etiquetar",
    onboarding_step_2_d:
      "Cada análisis se guarda automáticamente en tu historial. Añade etiquetas (#actor, #campaña, #tema) para activar Tendencias agregadas, briefings PDF y alertas semanales por correo.",
    onboarding_step_3_t: "Exportar y compartir",
    onboarding_step_3_d:
      "Descarga el análisis como PDF profesional o Markdown. Genera un Kit de prensa con resumen ejecutivo, citas y tweet listo. Activa tu Press Kit Público para compartir con periodistas.",
    onboarding_skip: "Saltar",
    onboarding_back: "Atrás",
    onboarding_next: "Siguiente",
    onboarding_finish: "Empezar",
    onboarding_step_n: "Paso",
    onboarding_of: "de",
    auth_login_title: "Acceso al laboratorio",
    auth_register_title: "Crear cuenta",
    auth_email: "Correo electrónico",
    auth_password: "Contraseña",
    auth_name: "Nombre",
    auth_submit_login: "Acceder",
    auth_submit_register: "Crear cuenta",
    auth_no_account: "¿Sin cuenta?",
    auth_have_account: "¿Ya tienes cuenta?",
    dash_input_title: "Fragmento de discurso a analizar",
    dash_input_placeholder: "Pega aquí el texto, transcripción, declaración o tweet del actor político…",
    dash_model: "Modelo de análisis",
    dash_run: "Ejecutar análisis",
    dash_running: "Analizando…",
    dash_tab_text: "Texto",
    dash_tab_file: "Archivo",
    dash_tab_audio: "Audio",
    dash_upload_file: "Sube .txt o .pdf",
    dash_upload_audio: "Sube mp3, m4a, wav, webm (máx 25MB)",
    dash_transcribe: "Transcribir y cargar",
    dash_history: "Análisis previos",
    dash_no_history: "Aún no hay análisis guardados.",
    dash_signature_label: "FIRMA INSTITUCIONAL",
    dash_chars: "caracteres",
    dash_min_chars: "Se requieren al menos 20 caracteres",
    dash_delete: "Eliminar",
    dash_view: "Ver",
    press_mode: "Modo Prensa",
    press_generating: "Generando kit…",
    dash_search: "Buscar en historial…",
    dash_tags_filter: "Filtrar por etiqueta",
    dash_all_tags: "Todas",
    dash_compare_select: "Comparar",
    dash_compare_active: "Seleccionado para comparar",
    dash_compare_run: "Comparar A vs B →",
    dash_compare_clear: "Limpiar",
    detail_tags: "Etiquetas",
    detail_tags_add: "Añadir etiqueta y Enter",
    detail_tags_save: "Guardar etiquetas",
    detail_export_md: "Exportar Markdown",
    detail_export_pdf: "Exportar PDF",
    compare_title: "Comparador estratégico",
    compare_loading: "Generando comparación…",
    compare_section_a: "Discurso A",
    compare_section_b: "Discurso B",
    compare_section_ai: "Análisis comparativo (IA)",
    compare_regenerate: "Regenerar comparación",
    compare_back: "Volver al panel",
    compare_pick_two: "Selecciona exactamente dos análisis en el historial para comparar.",
    compare_view_compact: "Compacta",
    compare_view_full: "Completa",
    compare_view_label: "Vista",
    compact_soph_label: "Sofisticación",
    compact_mech_label: "Mecanismo dominante",
    compact_obj_label: "Objetivo principal",
    trends_title: "Tendencias por actor",
    trends_subtitle: "Patrones agregados a partir de los análisis ya guardados.",
    trends_no_data: "Aún no hay análisis con etiquetas. Añade etiquetas a tus análisis para que aparezcan aquí.",
    trends_nav: "Tendencias",
    trends_count: "análisis",
    trends_first_seen: "Primer registro",
    trends_last_seen: "Última actividad",
    trends_avg_soph: "Sofisticación promedio",
    trends_no_score: "—",
    trends_view_detail: "Ver detalle",
    trends_back: "Volver a tendencias",
    trends_top_mechanisms: "Mecanismos retóricos más frecuentes",
    trends_top_objectives: "Objetivos estratégicos detectados",
    trends_sophistication_dist: "Distribución de sofisticación",
    trends_timeline: "Evolución temporal (por semana)",
    trends_recent: "Últimos análisis",
    trends_min_filter: "Mínimo de análisis",
    soph_basico: "Básico",
    soph_intermedio: "Intermedio",
    soph_avanzado: "Avanzado",
    soph_experto: "Experto",
    detail_back: "Volver al panel",
    detail_input_label: "TEXTO ANALIZADO",
    detail_result_label: "ANÁLISIS",
    detail_model: "Modelo",
    detail_date: "Fecha",
    lang_label: "ES",
    nav_about: "Manifiesto",
    // Pricing & billing
    nav_pricing: "Precios",
    nav_billing: "Mi plan",
    pricing_hero_eyebrow: "· PRECIOS · SUSCRIPCIÓN MENSUAL",
    pricing_hero_title: "Tres niveles. Un mismo método.",
    pricing_hero_lead:
      "Elige cómo usar GalascioDAS™. Suscripción recurrente vía Stripe. Cancela cuando quieras desde el portal de gestión.",
    pricing_legal:
      "Importes en EUR · IVA no incluido · El cobro recurrente lo gestiona Stripe. La fuente de verdad del estado de tu suscripción es nuestro webhook firmado.",
    plan_beta_name: "Beta individual",
    plan_beta_tagline: "Para iniciar tu práctica de análisis.",
    plan_pro_name: "Profesional",
    plan_professional_name: "Profesional",
    plan_pro_tagline: "Para periodistas, consultores y equipos de comunicación.",
    plan_consulting_name: "Consultoría + herramienta",
    plan_consulting_tagline: "Acompañamiento estratégico + acceso completo.",
    plan_free_name: "Plan gratuito",
    plan_legacy_name: "Acceso heredado",
    plan_per_month: "/mes",
    plan_feature_analyze: "Análisis ilimitados por protocolo de 5 fases",
    plan_feature_history: "Historial con búsqueda full-text",
    plan_feature_export: "Exportación PDF / Markdown con branding",
    plan_feature_trends: "Tendencias por actor (gráficos, KPIs, timeline)",
    plan_feature_compare: "Comparativo masivo (2-6 análisis)",
    plan_feature_alerts: "Alertas semanales por email",
    plan_feature_briefings: "Briefings PDF (actor + corpus)",
    plan_feature_press_kit: "Press kit público no listado",
    plan_feature_consulting: "Sesión mensual de consultoría estratégica",
    plan_feature_priority: "Soporte prioritario",
    plan_cta_subscribe: "Suscribirme",
    plan_cta_contact: "Solicitar acceso",
    plan_cta_current: "Tu plan actual",
    plan_cta_loading: "Procesando…",
    plan_locked: "Bloqueado en este plan",
    plan_included: "Incluido",
    plan_recommended: "Recomendado",
    pricing_faq_title: "Preguntas frecuentes",
    pricing_faq_q1: "¿Cómo cancelo?",
    pricing_faq_a1:
      "Desde Mi plan accedes al portal de Stripe y cancelas en un clic. Conservas el acceso hasta el final del periodo facturado.",
    pricing_faq_q2: "¿Cambios de plan?",
    pricing_faq_a2:
      "Sí, puedes cambiar de Beta a Profesional desde el portal de Stripe. El prorrateo lo aplica Stripe automáticamente.",
    pricing_faq_q3: "¿Hay prueba gratuita?",
    pricing_faq_a3:
      "No por ahora. Cualquier usuario puede registrarse gratis y ver la página de precios; el análisis se desbloquea al suscribirse.",
    pricing_faq_q4: "¿Mi cuenta existente?",
    pricing_faq_a4:
      "Si ya tenías cuenta antes del lanzamiento de Stripe, conservas acceso completo (plan legacy). No tienes que hacer nada.",
    billing_title: "Mi plan",
    billing_status_active: "Activa",
    billing_status_canceled: "Cancelada",
    billing_status_past_due: "Pago pendiente",
    billing_status_none: "Sin suscripción",
    billing_status_incomplete: "Incompleta",
    billing_status_trialing: "Periodo de prueba",
    billing_status_legacy: "Acceso heredado (legacy)",
    billing_manage: "Gestionar suscripción",
    billing_manual_managed:
      "Tu suscripción se gestiona manualmente por el equipo. Para cambios, contacta con nosotros.",
    billing_no_premium: "Tu plan actual no incluye funciones premium.",
    billing_premium_locked: "Esta función está disponible en los planes Profesional o Consultoría.",
    billing_view_plans: "Ver planes",
    billing_success_title: "¡Suscripción activada!",
    billing_success_lead:
      "Estamos confirmando tu pago con Stripe. La activación es inmediata, puedes refrescar si no la ves todavía.",
    billing_success_refresh: "Refrescar mi plan",
    billing_canceled_title: "Pago cancelado",
    billing_canceled_lead: "No se ha cobrado nada. Puedes volver a intentarlo cuando quieras.",
    billing_contact_subject: "Solicitud de plan Consultoría + herramienta",
    contact_email: "contacto@galasciodas.com",
  },
  en: {
    brand: "GalascioDAS",
    tagline: "Discourse Analysis System · Political Strategy",
    nav_login: "Sign in",
    nav_register: "Register",
    nav_logout: "Sign out",
    nav_dashboard: "Workspace",
    hero_eyebrow: "STRATEGIC DECODING OF POLITICAL DISCOURSE",
    hero_title: "It's not about truth or lies.\nIt's about strategic architecture.",
    hero_lead:
      "GalascioDAS does not evaluate whether a politician tells the truth. It decodes the rhetorical structure, the cognitive framing, and the deep intent behind every word uttered in the public arena.",
    hero_cta_start: "Start analysis",
    hero_cta_learn: "How it works",
    disciplines_title: "Four integrated disciplines",
    disc_1_t: "Computational rhetorical analysis",
    disc_1_d: "Algorithmic detection and naming of rhetorical devices and persuasion mechanisms.",
    disc_2_t: "Critical Discourse Analysis (CDA)",
    disc_2_d: "Examination of semantic elisions, euphemisms, and identity-activation vocabulary.",
    disc_3_t: "Strategic intent modeling",
    disc_3_d: "Inferring the real political objective beyond the declared topic.",
    disc_4_t: "Narrative coherence analysis",
    disc_4_d: "Evaluation of the cognitive frame installed and what is intentionally left out.",
    phases_title: "Five-phase protocol",
    phase_1: "Surface Radiography",
    phase_2: "Rhetorical Mechanism Detection",
    phase_3: "Cognitive Framing Analysis",
    phase_4: "Deep Strategy Inference",
    phase_5: "Final Strategic Map",
    footer_signature: "GalascioDAS™ · System developed by Michael A. Galascio",
    // Sprint 1 UX strings
    cta_paste_hint: "Paste a fragment of speech to begin.",
    tags_hint:
      "Add tags (e.g. #actor) to enable aggregated trends and PDF reports for this actor.",
    delete_confirm:
      "Delete this analysis? Tags and associated press kit will also be lost.",
    press_kit_share_hint: "Activate the press kit to enable sharing.",
    nav_my_press_kit: "My Press Kit",
    detail_press_kit_title: "Generate Press Kit for this analysis",
    detail_press_kit_lead:
      "Executive summary, key quotes and ready-to-share tweet.",
    tip_sophistication:
      "Strategic sophistication: level of elaboration of the discourse (basic → expert), inferred from the combined use of rhetorical mechanisms, framing and strategic depth.",
    tip_mechanism:
      "Dominant rhetorical mechanism: primary persuasive technique detected (e.g. polarization, appeal to fear, false equivalence, moral hyperbole).",
    tip_framing:
      "Cognitive framing: interpretive frame activated to condition how facts are understood (e.g. protection frame, victim frame, future frame).",
    tip_deep_strategy:
      "Deep strategy: political objective inferred beyond the declared topic (e.g. consolidate electoral base, displace rival, set the agenda).",
    sample_text_btn: "Load sample speech",
    cost_est_hint: "Estimated cost per analysis (approximate).",
    // /docs page
    docs_nav: "Documentation",
    docs_eyebrow: "· DOCUMENTATION · METHODOLOGY",
    docs_title: "How GalascioDAS works",
    docs_lead:
      "GalascioDAS does not evaluate whether a politician tells the truth. It decodes the rhetorical structure, cognitive framing and deep intent behind every word uttered in the public space. This page explains the methodology, the five-phase protocol and the limits of the system.",
    docs_what_eyebrow: "· WHAT IT IS",
    docs_what_title: "One system, four disciplines",
    docs_what_body:
      "GalascioDAS™ is a discourse-analysis system for political speech developed by Michael A. Galascio. It integrates computational rhetoric, critical discourse analysis (CDA), strategic intent modelling and narrative coherence analysis. It is not a fact-checker or a bias detector: it is an instrument to make the strategic architecture of public discourse visible.",
    docs_protocol_eyebrow: "· PROTOCOL · FIVE PHASES",
    docs_protocol_title: "How each discourse is analysed",
    docs_phase_1_d:
      "Identification of actor, linguistic register, dominant tone, declared topic, evoked audience. The minimum reading required before any inference.",
    docs_phase_2_d:
      "Detection and algorithmic naming of persuasive mechanisms: polarization, appeal to fear, false equivalence, moral hyperbole, victimization, dehumanization, historical anchoring, among others.",
    docs_phase_3_d:
      "Identification of the activated interpretive frame: protection, victim, future, decline, restoration, border. The frame conditions how the receiver understands facts before evaluating them.",
    docs_phase_4_d:
      "Inference of the real political objective beyond the declared topic: consolidate base, displace rival, set agenda, neutralize crisis, rebuild symbolic capital.",
    docs_phase_5_d:
      "Synthesis with a strategic verdict, dominant mechanism, primary cognitive frame and sophistication level (basic → expert).",
    docs_glossary_eyebrow: "· GLOSSARY",
    docs_glossary_title: "Key terms",
    docs_term_sophistication: "Strategic sophistication",
    docs_term_sophistication_d:
      "Level of elaboration of the discourse, inferred from the combined use of rhetorical mechanisms, framing and strategic depth. Scale: basic, intermediate, advanced, expert.",
    docs_term_framing: "Cognitive framing",
    docs_term_framing_d:
      "Interpretive frame activated to condition how facts are understood. Not what is said, but the lens through which the listener is invited to read it.",
    docs_term_mechanism: "Rhetorical mechanism",
    docs_term_mechanism_d:
      "Specific persuasive technique detected in the text. Each discourse typically has one dominant mechanism and several secondary ones.",
    docs_term_objective: "Strategic objective",
    docs_term_objective_d:
      "Political purpose inferred from the discourse, beyond the explicit topic. Expressed as action: consolidate, displace, instal, neutralize.",
    docs_term_narrative: "Narrative",
    docs_term_narrative_d:
      "Symbolic thread connecting several discourses by the same actor. Narrative is observed in aggregates (Trends), not in an isolated analysis.",
    docs_term_derived: "Derived inference",
    docs_term_derived_d:
      "A result that does NOT come from a new LLM analysis, but from statistical aggregation over already-saved analyses (Trends, briefings, distributions).",
    docs_not_eyebrow: "· LIMITS",
    docs_not_title: "What GalascioDAS does NOT do",
    docs_not_1_t: "Does not verify facts",
    docs_not_1_d:
      "If a discourse asserts economic data or historical events, GalascioDAS does not cross-check that information against sources. Factual verification requires other tools.",
    docs_not_2_t: "Does not replace expert judgment",
    docs_not_2_d:
      "It is a support instrument. A political analyst, journalist or researcher is still required to interpret the result in context.",
    docs_not_3_t: "Does not assert psychological intent as fact",
    docs_not_3_d:
      "The deep-strategy phase is a probabilistic inference about the discourse, not a diagnosis of the actor's mind. Rhetoric is not conflated with personality.",
    docs_use_eyebrow: "· USE CASES",
    docs_use_title: "For whom",
    docs_use_journalists_t: "Journalists",
    docs_use_journalists_d:
      "Identify the dominant mechanism of a statement and cite it with technical precision instead of vague adjectives like 'demagogy' or 'populism'.",
    docs_use_consultants_t: "Consultants",
    docs_use_consultants_d:
      "Audit your own or your opponent's discourse, detect saturation of a mechanism, evaluate whether sophistication is aligned with the target audience.",
    docs_use_researchers_t: "Researchers",
    docs_use_researchers_d:
      "Build comparative corpora, generate PDF briefings by actor or topic, observe longitudinal evolution of cognitive frames.",
    docs_use_comms_t: "Communications teams",
    docs_use_comms_d:
      "Automatic press kits, weekly alerts per monitored actor, export to Markdown/PDF for internal reports.",
    docs_cta_try: "Try an analysis",
    docs_cta_sample: "Load sample speech",
    // Onboarding modal
    onboarding_eyebrow: "· WELCOME · QUICK TOUR",
    onboarding_title: "Three steps to begin",
    onboarding_lead:
      "Take 30 seconds to understand the flow. You can skip this guide any time.",
    onboarding_step_1_t: "Analyze",
    onboarding_step_1_d:
      "Paste a fragment of speech, upload a file or record audio. Pick one of the three models (claude / GPT-5.2 / gemini). Press Run analysis. If you have never used the system, try the \"Load sample speech\" button.",
    onboarding_step_2_t: "Save and tag",
    onboarding_step_2_d:
      "Each analysis is saved automatically to your history. Add tags (#actor, #campaign, #topic) to activate aggregated Trends, PDF briefings and weekly email alerts.",
    onboarding_step_3_t: "Export and share",
    onboarding_step_3_d:
      "Download the analysis as professional PDF or Markdown. Generate a Press Kit with executive summary, quotes and ready-to-share tweet. Activate your Public Press Kit to share with journalists.",
    onboarding_skip: "Skip",
    onboarding_back: "Back",
    onboarding_next: "Next",
    onboarding_finish: "Get started",
    onboarding_step_n: "Step",
    onboarding_of: "of",
    auth_login_title: "Enter the laboratory",
    auth_register_title: "Create account",
    auth_email: "Email",
    auth_password: "Password",
    auth_name: "Name",
    auth_submit_login: "Sign in",
    auth_submit_register: "Create account",
    auth_no_account: "No account yet?",
    auth_have_account: "Already have an account?",
    dash_input_title: "Discourse fragment to analyze",
    dash_input_placeholder: "Paste here the text, transcript, statement or tweet from the political actor…",
    dash_model: "Analysis model",
    dash_run: "Run analysis",
    dash_running: "Analyzing…",
    dash_tab_text: "Text",
    dash_tab_file: "File",
    dash_tab_audio: "Audio",
    dash_upload_file: "Upload .txt or .pdf",
    dash_upload_audio: "Upload mp3, m4a, wav, webm (max 25MB)",
    dash_transcribe: "Transcribe and load",
    dash_history: "Past analyses",
    dash_no_history: "No saved analyses yet.",
    dash_signature_label: "INSTITUTIONAL SIGNATURE",
    dash_chars: "characters",
    dash_min_chars: "At least 20 characters required",
    dash_delete: "Delete",
    dash_view: "View",
    press_mode: "Press Mode",
    press_generating: "Generating kit…",
    dash_search: "Search history…",
    dash_tags_filter: "Filter by tag",
    dash_all_tags: "All",
    dash_compare_select: "Compare",
    dash_compare_active: "Selected for comparison",
    dash_compare_run: "Compare A vs B →",
    dash_compare_clear: "Clear",
    detail_tags: "Tags",
    detail_tags_add: "Type a tag and press Enter",
    detail_tags_save: "Save tags",
    detail_export_md: "Export Markdown",
    detail_export_pdf: "Export PDF",
    compare_title: "Strategic comparator",
    compare_loading: "Generating comparison…",
    compare_section_a: "Discourse A",
    compare_section_b: "Discourse B",
    compare_section_ai: "Comparative analysis (AI)",
    compare_regenerate: "Regenerate comparison",
    compare_back: "Back to workspace",
    compare_pick_two: "Select exactly two analyses in the history to compare.",
    compare_view_compact: "Compact",
    compare_view_full: "Full",
    compare_view_label: "View",
    compact_soph_label: "Sophistication",
    compact_mech_label: "Dominant mechanism",
    compact_obj_label: "Primary objective",
    trends_title: "Trends by actor",
    trends_subtitle: "Aggregate patterns derived from your saved analyses.",
    trends_no_data: "No analyses with tags yet. Tag your analyses to see them here.",
    trends_nav: "Trends",
    trends_count: "analyses",
    trends_first_seen: "First seen",
    trends_last_seen: "Last activity",
    trends_avg_soph: "Avg sophistication",
    trends_no_score: "—",
    trends_view_detail: "View detail",
    trends_back: "Back to trends",
    trends_top_mechanisms: "Most frequent rhetorical mechanisms",
    trends_top_objectives: "Detected strategic objectives",
    trends_sophistication_dist: "Sophistication distribution",
    trends_timeline: "Temporal evolution (weekly)",
    trends_recent: "Latest analyses",
    trends_min_filter: "Min analyses",
    soph_basico: "Basic",
    soph_intermedio: "Intermediate",
    soph_avanzado: "Advanced",
    soph_experto: "Expert",
    detail_back: "Back to workspace",
    detail_input_label: "ANALYZED TEXT",
    detail_result_label: "ANALYSIS",
    detail_model: "Model",
    detail_date: "Date",
    lang_label: "EN",
    nav_about: "Manifesto",
    // Pricing & billing
    nav_pricing: "Pricing",
    nav_billing: "My plan",
    pricing_hero_eyebrow: "· PRICING · MONTHLY SUBSCRIPTION",
    pricing_hero_title: "Three tiers. One method.",
    pricing_hero_lead:
      "Choose how you use GalascioDAS™. Recurring subscription via Stripe. Cancel anytime from the billing portal.",
    pricing_legal:
      "Prices in EUR · Taxes not included · Recurring billing handled by Stripe. The source of truth for your subscription state is our signed webhook.",
    plan_beta_name: "Beta individual",
    plan_beta_tagline: "Start your analysis practice.",
    plan_pro_name: "Professional",
    plan_professional_name: "Professional",
    plan_pro_tagline: "For journalists, consultants and comms teams.",
    plan_consulting_name: "Consulting + tool",
    plan_consulting_tagline: "Strategic guidance + full access.",
    plan_free_name: "Free plan",
    plan_legacy_name: "Legacy access",
    plan_per_month: "/mo",
    plan_feature_analyze: "Unlimited 5-phase protocol analyses",
    plan_feature_history: "History with full-text search",
    plan_feature_export: "PDF / Markdown export with branding",
    plan_feature_trends: "Per-actor trends (charts, KPIs, timeline)",
    plan_feature_compare: "Bulk compare (2-6 analyses)",
    plan_feature_alerts: "Weekly email alerts",
    plan_feature_briefings: "PDF briefings (actor + corpus)",
    plan_feature_press_kit: "Public unlisted press kit",
    plan_feature_consulting: "Monthly strategic consulting session",
    plan_feature_priority: "Priority support",
    plan_cta_subscribe: "Subscribe",
    plan_cta_contact: "Request access",
    plan_cta_current: "Your current plan",
    plan_cta_loading: "Processing…",
    plan_locked: "Locked in this plan",
    plan_included: "Included",
    plan_recommended: "Recommended",
    pricing_faq_title: "Frequently asked",
    pricing_faq_q1: "How do I cancel?",
    pricing_faq_a1:
      "From My plan you access the Stripe portal and cancel with one click. You keep access until the end of the billing period.",
    pricing_faq_q2: "Plan changes?",
    pricing_faq_a2:
      "Yes, you can upgrade from Beta to Professional from the Stripe portal. Stripe auto-prorates.",
    pricing_faq_q3: "Free trial?",
    pricing_faq_a3:
      "Not for now. Anyone can sign up for free and see the pricing page; analyses unlock upon subscription.",
    pricing_faq_q4: "My existing account?",
    pricing_faq_a4:
      "If you had an account before the Stripe launch, you keep full access (legacy plan). Nothing to do.",
    billing_title: "My plan",
    billing_status_active: "Active",
    billing_status_canceled: "Canceled",
    billing_status_past_due: "Past due",
    billing_status_none: "No subscription",
    billing_status_incomplete: "Incomplete",
    billing_status_trialing: "Trial",
    billing_status_legacy: "Legacy access",
    billing_manage: "Manage subscription",
    billing_manual_managed:
      "Your subscription is managed manually by our team. For changes, contact us.",
    billing_no_premium: "Your current plan does not include premium features.",
    billing_premium_locked: "This feature is available on Professional or Consulting plans.",
    billing_view_plans: "View plans",
    billing_success_title: "Subscription activated!",
    billing_success_lead:
      "We're confirming your payment with Stripe. Activation is instant — refresh if you don't see it yet.",
    billing_success_refresh: "Refresh my plan",
    billing_canceled_title: "Payment canceled",
    billing_canceled_lead: "Nothing was charged. You can try again whenever you want.",
    billing_contact_subject: "Consulting + tool plan request",
    contact_email: "contacto@galasciodas.com",
  },
};
